import { createContext } from "react";

const FontListContext = createContext({});

export default FontListContext;
